exports["FR"] = require("./FR.js");
exports["UA"] = require("./UA.js");
exports["IT"] = require("./IT.js");
exports["LT"] = require("./LT.js");
exports["MT"] = require("./MT.js");
exports["PT"] = require("./PT.js");
exports["SM"] = require("./SM.js");
exports["CY"] = require("./CY.js");